import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";

const useSaveGroup = () => {
  return useMutation((params) => servicesUtils.postService("/accounts/groups/", params));
};

export default useSaveGroup;
